import { render, staticRenderFns } from "./AssessModal.vue?vue&type=template&id=01ad5866&scoped=true"
import script from "./AssessModal.vue?vue&type=script&lang=js"
export * from "./AssessModal.vue?vue&type=script&lang=js"
import style0 from "./AssessModal.vue?vue&type=style&index=0&id=01ad5866&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01ad5866",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/__flow_work/__flow_builds/fb587e26-24b6-43df-a4aa-75cb4eb3f6e2/workspace/aigoes-school-web_Adop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01ad5866')) {
      api.createRecord('01ad5866', component.options)
    } else {
      api.reload('01ad5866', component.options)
    }
    module.hot.accept("./AssessModal.vue?vue&type=template&id=01ad5866&scoped=true", function () {
      api.rerender('01ad5866', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/comUi/AssessModal.vue"
export default component.exports